var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1.5 -1.5 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recycle-bin-2--remove-delete-empty-bin-trash-garbage"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.795625 14.851875c0.8315625 12.9515625 1.6275 19.689375 2.1 22.896562499999998 0.24 1.621875 1.305 2.94375 2.8996874999999998 3.32625C12.965625 41.596875 16.7034375 42.1875 22.501875 42.1875c5.7984374999999995 0 9.5353125 -0.590625 11.7065625 -1.111875 1.59375 -0.38249999999999995 2.65875 -1.704375 2.89875 -3.32625 0.4734375 -3.2081250000000003 1.2684374999999999 -9.9459375 2.1 -22.9003125",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29.09625 6.7275c3.3375 0.061875 5.938124999999999 0.163125 7.801874999999999 0.2578125 2.240625 0.11249999999999999 4.321875 1.3059375 4.948124999999999 3.4603124999999997 0.09375 0.3234375 0.181875 0.6656249999999999 0.25875000000000004 1.0284375 0.369375 1.725 -0.9215625 3.2071875 -2.6793750000000003 3.35625 -2.83125 0.2390625 -8.0128125 0.5109375 -16.947187500000002 0.5109375 -8.9334375 0 -14.115937500000001 -0.271875 -16.94625 -0.5109375 -1.7587499999999998 -0.148125 -3.0571875 -1.640625 -2.6025 -3.345 0.1640625 -0.6140625000000001 0.36562500000000003 -1.1746874999999999 0.5775 -1.6725 0.7621874999999999 -1.7840625 2.596875 -2.7046875 4.53375 -2.8115625 1.7887499999999998 -0.09749999999999999 4.3921874999999995 -0.208125 7.8628125 -0.27375A6.5625 6.5625 0 0 1 21.909375 2.8125h1.183125a6.5625 6.5625 0 0 1 6.0046875 3.915Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 831",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16.875 23.4375 0.9375 9.375",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 832",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m28.125 23.4375 -0.9375 9.375",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.f9f3c2aff5ee42bed0be67574809f8d1.svg";
export { ForwardRef as ReactComponent };